export const EMPTY_ERROR = "Это поле обязательно"
